import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { utilService } from '../../../../core/services'
import { Button, PanelTitle, Panel } from '../../../atoms'
import * as interfaces from '../../../../static/interfaces'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  user: IJsonResponse
  payment_download_enabled: boolean
  use_payment_download_db: boolean
  use_payment_download_spreadsheet: boolean
}

const Index: React.FC<IProps> = props => {
  const { data: userData } = utilService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={userData}>
      <Panel>
        <Title>
          <PanelTitle title={I18n.t('payments.agent_title')} />
          {props.payment_download_enabled && (
            <div className="paymentDownload">
              {props.use_payment_download_db && (
                <Button small={true} primary={true}>
                  <a href={`/agent/payments`}>{I18n.t('payments.notice.download')}</a>
                </Button>
              )}
              {props.use_payment_download_spreadsheet && (
                <Button small={true} primary={true}>
                  <a href={`/agent/payments/spreadsheet`}>
                    {I18n.t('payments.notice.download_spreadsheet')}
                  </a>
                </Button>
              )}
            </div>
          )}
        </Title>
      </Panel>
    </SidebarLayout>
  )
}

const Title = styled.div`
  display: flex;
  align-items: center;
  .paymentDownload {
    margin-left: auto;
    display: flex;
    .Button {
      margin-left: 12px;
    }
  }
`

export default Index
